import { apiClient } from '../lib/apiClient';

export interface SupportTicketSummary {
  id: string;
  stationId: string;
  stationSlug: string;
  stationName: string | null;
  userId: string | null;
  email: string;
  contactName: string | null;
  category: string;
  categoryLabel: string;
  details: string;
  status: 'open' | 'in_progress' | 'completed';
  statusLabel: string;
  wizardStep: number | null;
  pageUrl: string | null;
  createdAt: string;
  updatedAt: string;
  completedAt: string | null;
  unreadForAdmin?: boolean;
}

export interface SupportTicketMessage {
  id: string;
  ticketId: string;
  senderUserId: string | null;
  senderRole: 'advertiser' | 'admin' | 'system';
  body: string;
  createdAt: string;
}

export interface SupportTicketDetail extends SupportTicketSummary {
  messages: SupportTicketMessage[];
}

export interface CreateSupportTicketPayload {
  stationSlug: string;
  email?: string;
  contactName?: string;
  category: string;
  details: string;
  wizardStep?: number;
  pageUrl?: string;
}

export function listMyTickets() {
  return apiClient.get<SupportTicketSummary[]>('/support/tickets/mine');
}

export function getTicket(id: string) {
  return apiClient.get<SupportTicketDetail>(`/support/tickets/${id}`);
}

export function createTicket(body: CreateSupportTicketPayload, anonymous = false) {
  return apiClient.post<{ ok: true; id: string; createdAt: string }>(
    '/support/tickets',
    body,
    { anonymous },
  );
}

export function addTicketMessage(ticketId: string, body: string) {
  return apiClient.post<{ id: string; createdAt: string }>(
    `/support/tickets/${ticketId}/messages`,
    { body },
  );
}

export function listAdminTickets() {
  return apiClient.get<SupportTicketSummary[]>('/admin/support/tickets');
}

export function getAdminUnreadCount() {
  return apiClient.get<{ count: number }>('/admin/support/tickets/unread-count');
}

export function getAdminTicket(id: string) {
  return apiClient.get<SupportTicketDetail>(`/admin/support/tickets/${id}`);
}

export function addAdminTicketMessage(ticketId: string, body: string) {
  return apiClient.post<{ id: string; createdAt: string }>(
    `/admin/support/tickets/${ticketId}/messages`,
    { body },
  );
}

export function updateAdminTicketStatus(
  ticketId: string,
  status: 'open' | 'in_progress' | 'completed',
) {
  return apiClient.patch<{ ok: true; status: string }>(
    `/admin/support/tickets/${ticketId}`,
    { status },
  );
}
